import { Typography } from '@cobliteam/ui/components';

import { HintPopup, Switch } from '@cobliteam/base-components';

const NoAccessHover = () => {
  return (
    <HintPopup
      title='Você não tem permissão para ver
      locais. Peça acesso ao administrador.'
      arrow
      placement='bottom'
    >
      <div className='mt-2.5 flex h-full items-center gap-2.5'>
        <Switch size='medium' disabled />
        <Typography variant='caption-bold' color='secondary'>
          Locais de interesse
        </Typography>
      </div>
    </HintPopup>
  );
};

export default NoAccessHover;
